import React from 'react'
import App from 'next/app'
import qs from 'qs'

import { GlobalContextProvider } from '~/core/context'
import { I18nContextProvider } from '~/core/i18n'
import { isBrowser, getDataFromLocalStorage } from '~/core/utils/functions'
import { AuthLayout } from 'components/layout'

import sites from './sites.json'
import '../public/styles/main.css'

export default class PbxApp extends App {
  // Prevent ASO for query fetching
  // https://nextjs.org/docs/advanced-features/automatic-static-optimization
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {}
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx)
    }
    return { pageProps }
  }

  getQuery(routerQuery = {}) {
    if (isBrowser()) {
      return qs.parse(window.location.search, { ignoreQueryPrefix: true })
    }
    return routerQuery
  }

  render() {
    const { Component, router } = this.props
    const { lang } = this.getQuery(router.query)

    const initialLanguage = lang || getDataFromLocalStorage('lang') || 'cz'
    const ChildComponent = <Component query={router.query} />

    return (
      <I18nContextProvider initialLanguage={initialLanguage}>
        <GlobalContextProvider>
          <AuthLayout router={router} sites={sites}>
            {ChildComponent}
          </AuthLayout>
        </GlobalContextProvider>
      </I18nContextProvider>
    )
  }
}
